var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIncomingCallBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0667 9.18479C10.0637 8.36581 5.93632 8.36581 1.93333 9.18479C0.832361 9.4265 0.0360291 10.3848 0 11.5115V12.5115C0 13.4319 0.746192 14.1781 1.66667 14.1781H3.66667C4.58714 14.1781 5.33333 13.4319 5.33333 12.5115V12.1481C7.10763 11.9908 8.89237 11.9908 10.6667 12.1481V12.5115C10.6667 13.4319 11.4129 14.1781 12.3333 14.1781H14.3333C15.2538 14.1781 16 13.4319 16 12.5115V11.5115C15.964 10.3848 15.1676 9.4265 14.0667 9.18479Z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66634 6.67802C8.12658 6.67802 8.49967 6.30493 8.49967 5.84469V2.65535C8.49967 2.19512 8.12658 1.82202 7.66634 1.82202C7.2061 1.82202 6.83301 2.19512 6.83301 2.65535V5.84469C6.83301 6.30493 7.2061 6.67802 7.66634 6.67802Z",
    fill: "#242424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.773 7.73342C10.9954 7.73384 11.2087 7.64497 11.365 7.48675L13.5923 5.24075C13.9165 4.9138 13.9143 4.38595 13.5873 4.06175C13.2604 3.73756 12.7325 3.7398 12.4083 4.06675L10.181 6.31475C9.94414 6.55368 9.87419 6.91157 10.0036 7.22209C10.1331 7.5326 10.4366 7.73482 10.773 7.73475V7.73342Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96879 7.48794C4.29279 7.8149 4.8205 7.81728 5.14745 7.49328C5.4744 7.16927 5.47679 6.64156 5.15278 6.31461L2.92545 4.06661C2.60144 3.73966 2.07374 3.73727 1.74679 4.06128C1.41983 4.38528 1.41744 4.91299 1.74145 5.23994L3.96879 7.48794Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIncomingCallBlackIcon);
export default __webpack_public_path__ + "static/media/phone-incoming-call-black-icon.a70293b80382fc72716d6ecc37133999.svg";
export { ForwardRef as ReactComponent };